module.exports = __webpack_public_path__ + "static/media/X.a1859c8f.svg";